// extracted by mini-css-extract-plugin
module.exports = {"description":"GroupsHierarchyForm_description__2lv3e","select":"GroupsHierarchyForm_select__23mDb"};